import { formatDataTest } from '@/common/dataTest/DataTest';
import { useInDialog } from '@/common/dialog/DialogScopeContext';
import { DesktopDateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { DateTime } from 'luxon';
import { useMemo } from 'react';
import { useFormFieldDef } from '../hooks/useFormFieldDef';

export const InstantFormField = ({ fieldDef }) => {
  const {
    value,        // ISO string like '2025-04-03T21:27:28Z'
    setValue,
    onBlur,
    error,
    helperText,
    label,
    disabled
  } = useFormFieldDef(fieldDef);

  const inDialog = useInDialog();

  const localDateTime = useMemo(() => {
    if (!value) return null;
    return DateTime.fromISO(String(value), { zone: 'utc' }).toLocal();
  }, [value]);

  const handleChange = (newValue) => {
    if (!newValue || !newValue.isValid) {
      setValue(null);
      return;
    }
    const utc = newValue.toUTC().toISO(); // Save as UTC ISO string
    setValue(utc);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterLuxon}>
      <DesktopDateTimePicker
        disabled={disabled}
        label={label}
        value={localDateTime}
        onChange={handleChange}
        format="yyyy-LL-dd hh:mm:ss a"
        slotProps={{
          actionBar: {
            actions: ['clear'],
          },
          textField: {
            helperText,
            error,
            onBlur,
            inputProps: {
              'data-test-id': formatDataTest(inDialog ? 'dialog' : 'main', 'form-field', fieldDef.displayName),
            }
          },
        }}
      />
    </LocalizationProvider>
  );
};
